import React from "react";
import "./History.css";
import Modal from "react-responsive-modal";
import { Col, FormControl } from "react-bootstrap";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "axios";
import { B2B_PROXY } from "../containers/assets/config";

export default class History extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.shouldUpdateHistory === true) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    return (
      <div>
        <Modal
          open={this.props.isHistoryModalOpen}
          onClose={this.props.onCloseHistoryModal}
          center
        >
          <Col md={12}>
            <form>
              <div className="col-md-4">
                <label>
                  <input
                    type="radio"
                    name="historyType"
                    value="TicketExtendedHistory_BRD"
                    checked={
                      this.props.historyType === "TicketExtendedHistory_BRD"
                    }
                    onChange={this.props.handleChangeOfHistoryRadioButtons}
                  />
                  Boarding
                </label>
              </div>

              <div className="col-md-4">
                <label>
                  <input
                    type="radio"
                    name="historyType"
                    value="TicketExtendedHistory_CNF"
                    checked={
                      this.props.historyType === "TicketExtendedHistory_CNF"
                    }
                    onChange={this.props.handleChangeOfHistoryRadioButtons}
                  />
                  Confirmation
                </label>
              </div>

              <div className="col-md-4">
                <label>
                  <input
                    type="radio"
                    name="historyType"
                    value="TicketExtendedHistory_ALL"
                    checked={
                      this.props.historyType === "TicketExtendedHistory_ALL"
                    }
                    onChange={this.props.handleChangeOfHistoryRadioButtons}
                  />
                  All
                </label>
              </div>
              <div
                className="col-md-3 col-sm-12"
                style={{ marginTop: 10, marginBottom: 10, marginLeft: 15 }}
              >
                <FormControl
                  componentClass="select"
                  value={this.props.selectedCheckpoint}
                  name="selectedCheckpoint"
                  onChange={this.props.handleChangeOfCheckpoint}
                >
                  <option key="" value="">
                    Select Checkpoint
                  </option>
                  {this.props.CheckPoints.map((CheckPoint, index) => {
                    return (
                      <option
                        key={CheckPoint["@attributes"].Id}
                        value={CheckPoint["@attributes"].Id}
                      >
                        {CheckPoint["@attributes"].Description}
                      </option>
                    );
                  })}
                </FormControl>
              </div>
            </form>
          </Col>
          <div className="mod" id="historyContainer">
            <div className="col-md-12 col-xs-12 resultsRHistory">
              <div className="col-md-1 col-xs-1 resultTick">Company</div>
              <div className="col-md-1 col-xs-1 resultTick">Vessel</div>
              <div className="col-md-1 col-xs-1 resultTick">IMO</div>
              <div className="col-md-1 col-xs-1 resultTick">Departure Date</div>
              <div className="col-md-1 col-xs-1 resultTick">Booking Number</div>
              <div className="col-md-1 col-xs-1 resultTick">Ticket Number</div>
              <div className="col-md-1 col-xs-1 resultTick">Type</div>
              <div className="col-md-1 col-xs-1 resultTick">
                Surname Plates Name
              </div>
              <div className="col-md-1 col-xs-1 resultTick">Insert Date</div>
              <div className="col-md-1 col-xs-1 resultTick">Delete Date</div>
              <div className="col-md-1 col-xs-1 resultTick">Insert User</div>
              <div className="col-md-1 col-xs-1 resultTick">Delete User</div>
            </div>
            {this.props.reservationHistory.map((historicalData, index) => {
              let bookData = historicalData.BookIdAnalysis;
              return (
                <div
                  className="col-md-12 col-xs-12 resultsRTicks"
                  key={historicalData.TicketNumber}
                >
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.Company}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.Vesselname}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.IMO}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.DepartureDate}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.BookingNumber}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.TicketNumber}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.Type}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.SurnamePlates} {historicalData.Name}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.InsertDate}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.DeleteDate}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.InsertUser}
                  </div>
                  <div className="col-md-1 col-xs-1 resultTick">
                    {historicalData.DeleteUser}
                  </div>
                  <div className="col-md-12 col-xs-12 resultTick">
                    <div className="col-md-12 col-xs-12 resultsRHistory">
                      <div className="col-md-3 col-xs-2 resultTick">
                        Departure
                      </div>
                      <div className="col-md-2 col-xs-2 resultTick">Vessel</div>
                      <div className="col-md-3 col-xs-2 resultTick">
                        Transaction type
                      </div>
                      <div className="col-md-3 col-xs-2 resultTick">
                        Transaction Date
                      </div>
                      <div className="col-md-1 col-xs-2 resultTick">User</div>
                    </div>
                    {bookData.length > 0 ? (
                      bookData.map((data, index) => {
                        return (
                          <div className="col-md-12 col-xs-12">
                            <div className="col-md-3 col-xs-2 resultTick">
                              {data.DepartureDate}
                            </div>
                            <div className="col-md-2 col-xs-2 resultTick">
                              {data.VesselName}
                            </div>
                            <div className="col-md-3 col-xs-2 resultTick">
                              {data.TransType}
                            </div>
                            <div className="col-md-3 col-xs-2 resultTick">
                              {data.TransDate}
                            </div>
                            <div className="col-md-1 col-xs-2 resultTick">
                              {data.User}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="col-md-12 col-xs-12">
                        <div className="col-md-3 col-xs-2 resultTick">
                          {historicalData.BookIdAnalysis.DepartureDate}
                        </div>
                        <div className="col-md-2 col-xs-2 resultTick">
                          {historicalData.BookIdAnalysis.VesselName}
                        </div>
                        <div className="col-md-3 col-xs-2 resultTick">
                          {historicalData.BookIdAnalysis.TransType}
                        </div>
                        <div className="col-md-3 col-xs-2 resultTick">
                          {historicalData.BookIdAnalysis.TransDate}
                        </div>
                        <div className="col-md-1 col-xs-2 resultTick">
                          {historicalData.BookIdAnalysis.User}
                        </div>
                      </div>
                    )}
                    {this.props.checkValidity.map((historyValidity, index) => {
                      if (
                        historyValidity.TicketNumber ==
                        historicalData.TicketNumber
                      ) {
                        let checkpointName = "";
                        for (
                          let i = 0;
                          i < this.props.CheckPoints.length;
                          i++
                        ) {
                          if (
                            this.props.CheckPoints[i]["@attributes"].Id ==
                            historyValidity.CheckPointId
                          ) {
                            checkpointName =
                              this.props.CheckPoints[i]["@attributes"]
                                .Description;
                          }
                        }

                        let allowedDateTime = historyValidity.ValidationDate;
                        let allowedDateTimeArray = allowedDateTime.split(" ");
                        let allowedDateArray =
                          allowedDateTimeArray[0].split("-");

                        let allowedDateString =
                          allowedDateArray[2] +
                          "/" +
                          allowedDateArray[1] +
                          "/" +
                          allowedDateArray[0] +
                          " " +
                          allowedDateTimeArray[1];

                        return (
                          <div className="col-md-12 col-xs-12">
                            <div className="col-md-3 col-xs-2 resultTick"></div>
                            <div className="col-md-2 col-xs-2 resultTick"></div>
                            <div className="col-md-3 col-xs-2 resultTick">
                              Check Validity - Checkpoint: {checkpointName}
                            </div>
                            <div className="col-md-3 col-xs-2 resultTick">
                              {allowedDateString}
                            </div>
                            <div className="col-md-1 col-xs-2 resultTick">
                              {historyValidity.UserName}
                            </div>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </div>
                </div>
              );
            })}
            <div className="col-md-12 buttonContainer">
              <div
                className="col-md-3"
                onClick={() => {
                  this.props.onCloseHistoryModal();
                }}
              >
                <button className="btn btn-primary btn btn-lg">Close</button>
              </div>
              <div
                className="col-md-3"
                onClick={() => {
                  this.props.printReservationHistoryToXlsx();
                }}
              >
                <button
                  className="btn btn-success btn btn-lg"
                  style={{ backgroundColor: "green" }}
                >
                  Export to Xlsx
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/History.js